// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSafetyCertificateOutlinedSvg from "@fishx/icons-svg/es/asn/PSafetyCertificateOutlined";
import FishxIcon from '../components/FishxIcon';

var PSafetyCertificateOutlined = function PSafetyCertificateOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSafetyCertificateOutlinedSvg
  }));
};

PSafetyCertificateOutlined.displayName = 'PSafetyCertificateOutlined';
export default React.forwardRef(PSafetyCertificateOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSafetyCertificateOutlined.js
// module id = 3609
// module chunks = 0